import {
  Box,
  Container,
  createTheme,
  FormControl,
  Link,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import Title from "../../components/Pages/Title";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useState } from "react";
import Pagination from "../../components/Pagination";
import { useRecoilState } from "recoil";
import { ThemeLight } from "../../state/ThemeLight";

const ForkBlock = () => {
  const loopData: number[] = [];

  const [limit, setLimit] = useState(25);
  const [total] = useState(0);
  const [page, setPage] = useState(0);

  const handleChange = (event: SelectChangeEvent) => {
    setLimit(parseInt(event.target.value));
    setPage(0);
  };

  return (
    <>
      <Title
        title="Forked Blocks"
        smallTitle={`Excluded blocks as a result of "Chain Reorganizations"`}
      />

      <Container className="container-xxl pt-5 pb-12">
        <Box className="card">
          <Box className="card-body">
            <Box className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <Box>
                <span className="text-dark content-center gap-1">
                  A total of 0 forked blocks found
                </span>
              </Box>
              <Box className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <Pagination
                  limit={limit}
                  page={page}
                  setPage={setPage}
                  total={total}
                />
              </Box>
            </Box>
          </Box>

          <TableContainer component={Paper} className="box-shadow-0">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" width={1}>
                    Height
                  </TableCell>
                  <TableCell align="left">
                    <Tooltip title="Click show Datetime Format" placement="top">
                      <Link>Age</Link>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="left">Txn</TableCell>
                  <TableCell align="left">Uncles</TableCell>
                  <TableCell align="left">Fee Recipient</TableCell>
                  <TableCell align="left">Gas Limit</TableCell>
                  <TableCell align="left">Difficulty</TableCell>
                  <TableCell align="left">Reward</TableCell>
                  <TableCell align="left">ReorgDepth</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow>
                  <div className="no-data">No Data Found</div>
                  <div
                    style={{
                      height: "100px",
                    }}
                  ></div>
                </TableRow>
                {loopData.map((data) => (
                  <TableRow>
                    <TableCell>
                      <Box className="hash-tag text-truncate">
                        <Link
                          href="/tx/0xcbddfe8514f46e34a7f2ed5ecc5853ee69f0e3e7bde1022341cdf68534aaeb95"
                          className="myFnExpandBox_searchVal"
                        >
                          21998412
                        </Link>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Tooltip title={"7 secs ago"} placement="top">
                        <Box rel="tooltip"> 2 hrs 25 mins ago</Box>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Box className="hash-tag text-truncate">123</Box>
                    </TableCell>
                    <TableCell>0</TableCell>
                    <TableCell>
                      <Tooltip title="Copy Address" placement="top">
                        <Link href="/block/19049995">rysnc builder </Link>
                      </Tooltip>
                      <ContentCopyIcon className="text-icon text-muted" />
                    </TableCell>
                    <TableCell>30,000,000</TableCell>
                    <TableCell>0.000 TH</TableCell>
                    <TableCell>0.03245 UPC</TableCell>
                    <TableCell>1</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box className="card-body">
            <Box className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <Box
                id="ContentPlaceHolder1_pageRecords"
                className="d-flex align-items-center gap-2 text-nowrap text-muted"
              >
                Show:
                <FormControl sx={{ m: 1, minWidth: 70 }}>
                  <Select
                    value={limit.toString()}
                    onChange={handleChange}
                    displayEmpty
                    size="small"
                    sx={{
                      fontSize: "12px",
                    }}
                  >
                    <MenuItem
                      value={10}
                      sx={{
                        fontSize: "12px;",
                      }}
                    >
                      10
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={25}
                    >
                      25
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={50}
                    >
                      50
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={100}
                    >
                      100
                    </MenuItem>
                  </Select>
                </FormControl>
                Records
              </Box>
              <Box className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <Pagination
                  limit={limit}
                  page={page}
                  setPage={setPage}
                  total={total}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default ForkBlock;
